import { Iris } from '@/rec-cache/rec-cache-types'

export const constraintDefinitions = [
  {
    sources: [Iris.recRealEstate],
    relation: Iris.recIncludes,
    targets: [Iris.recBuilding],
    min: null,
    max: 1,
  },
  {
    sources: [Iris.recLevel, Iris.recSubBuilding],
    relation: Iris.recIsPartOf,
    targets: [Iris.recBuilding],
    min: 1,
    max: null,
  },
  {
    sources: [Iris.recLevel],
    relation: Iris.recIsPartOf,
    targets: [Iris.recSubBuilding],
    min: 1,
    max: null,
  },
  {
    sources: [Iris.brickSystem],
    relation: Iris.recIncludes,
    targets: [Iris.brickEquipment, Iris.brickSensorEquipment],
    min: null,
    max: 1,
  },
  {
    sources: [Iris.recBuilding],
    relation: Iris.recIsLocationOf,
    targets: [Iris.brickSystem],
    min: null,
    max: 1,
  },
  {
    sources: [Iris.recSubBuilding],
    relation: Iris.recIsLocationOf,
    targets: [Iris.brickSystem],
    min: null,
    max: 1,
  },
  {
    sources: [Iris.brickPoint],
    relation: Iris.brickIsPointOf,
    targets: [Iris.brickEquipment, Iris.brickSensorEquipment],
    min: 1,
    max: null,
  },
  {
    sources: [Iris.brickEquipment],
    relation: Iris.brickFeeds,
    targets: [Iris.brickEquipment, Iris.recSpace],
    min: null,
    max: null,
  },
  {
    sources: [Iris.recAgent],
    relation: Iris.recOwns,
    targets: [Iris.recRealEstate],
    min: null,
    max: null,
  },
  {
    sources: [Iris.recSpace, Iris.recAsset, Iris.recSystem],
    relation: Iris.recRelatedTo,
    targets: [Iris.recServiceObject],
    min: null,
    max: null,
  },
  // Asset relationships - locatedIn (Asset/Equipment → Space)
  {
    sources: [Iris.recAsset, Iris.brickEquipment, Iris.brickSensorEquipment],
    relation: Iris.recLocatedIn,
    targets: [Iris.recSpace],
    min: null,
    max: 1, // Asset can only be located in one space
  },
  // Asset relationships - servicedBy (Asset → Agent)
  {
    sources: [Iris.recAsset, Iris.brickEquipment, Iris.brickSensorEquipment],
    relation: Iris.recServicedBy,
    targets: [Iris.recAgent],
    min: null,
    max: null,
  },
  // Asset relationships - manufacturedBy (Asset → Agent)
  {
    sources: [Iris.recAsset, Iris.brickEquipment, Iris.brickSensorEquipment],
    relation: Iris.recManufacturedBy,
    targets: [Iris.recAgent],
    min: null,
    max: 1, // Asset typically has one manufacturer
  },
  // Asset relationships - installedBy (Asset → Agent)
  {
    sources: [Iris.recAsset, Iris.brickEquipment, Iris.brickSensorEquipment],
    relation: Iris.recInstalledBy,
    targets: [Iris.recAgent],
    min: null,
    max: 1, // Asset installed by one agent
  },
  // Asset relationships - commissionedBy (Asset → Agent)
  {
    sources: [Iris.recAsset, Iris.brickEquipment, Iris.brickSensorEquipment],
    relation: Iris.recCommissionedBy,
    targets: [Iris.recAgent],
    min: null,
    max: 1, // Asset commissioned by one agent
  },
  // Asset relationships - mountedOn (Asset → BuildingElement)
  {
    sources: [Iris.recAsset, Iris.brickEquipment, Iris.brickSensorEquipment],
    relation: Iris.recMountedOn,
    targets: [Iris.recBuildingElement],
    min: null,
    max: 1, // Asset mounted on one building element
  },
  // Brick Curve Semantics - Function input relationship (Function → Point)
  {
    sources: [Iris.brickFunction],
    relation: Iris.brickInput,
    targets: [Iris.brickPoint],
    min: null,
    max: null, // Function can have multiple inputs
  },
  // Brick Curve Semantics - Break point pair relationships
  {
    sources: [Iris.brickBreakPointPair],
    relation: Iris.brickHasIndependentBreakPoint,
    targets: [Iris.brickIndependentBreakPoint],
    min: 1, // Required
    max: 1, // One per pair
  },
  {
    sources: [Iris.brickBreakPointPair],
    relation: Iris.brickHasDependentBreakPoint,
    targets: [Iris.brickDependentBreakPoint],
    min: 1, // Required
    max: 1, // One per pair
  },
  {
    sources: [Iris.brickBreakPointPair],
    relation: Iris.brickIsBreakPointPairOf,
    targets: [Iris.brickCurveFunction],
    min: 1, // Required - must belong to a curve
    max: null, // Can belong to one curve
  },
]
